import { render, staticRenderFns } from "./GeoStudentStops.vue?vue&type=template&id=ff59f6a8&scoped=true&"
import script from "./GeoStudentStops.vue?vue&type=script&lang=js&"
export * from "./GeoStudentStops.vue?vue&type=script&lang=js&"
import style0 from "./GeoStudentStops.vue?vue&type=style&index=0&id=ff59f6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff59f6a8",
  null
  
)

export default component.exports